/* eslint-disable no-undef */
import objectFitImages from 'object-fit-images';
import { judgeIE } from './modules/browser';
import './modules/fillHeight';
import { router } from './router';
import { TopPage } from './routes/Top';
import smoothscroll from 'smoothscroll-polyfill';

export const store = {
  isIE: false
};

// IE判定処理
store.isIE = judgeIE();

// scrollIntoViewのPolyfill
smoothscroll.polyfill();

// object-fitのpolyfill
objectFitImages();

document.addEventListener('DOMContentLoaded', () => {
  document.body.classList.add('is-loaded');

  router
    .route('/jp/ja/sf2030', (_req) => {
      TopPage.exec();
    })
    .route('/global/:lang(en|cn)/sf2030', (req) => {
      const lang = req.params.lang;
      TopPage.exec({ lang });
    })
    .exec();
});
